import _regeneratorRuntime from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _classCallCheck from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { ExternalInteractorBase } from "../../../Core/Utils/ExternalInteractorBase";
import { isInArray } from "../../../Utils/Utils";
export var TrailMaker =
/*#__PURE__*/
function (_ExternalInteractorBa) {
  _inherits(TrailMaker, _ExternalInteractorBa);

  function TrailMaker(container) {
    var _this;

    _classCallCheck(this, TrailMaker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TrailMaker).call(this, container));
    _this.delay = 0;
    return _this;
  }

  _createClass(TrailMaker, [{
    key: "interact",
    value: function interact(delta) {
      var _a, _b, _c, _d, container, options, trailOptions, optDelay, canEmit;

      return _regeneratorRuntime.async(function interact$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.container.retina.reduceFactor) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              container = this.container, options = container.actualOptions, trailOptions = options.interactivity.modes.trail, optDelay = trailOptions.delay * 1000 / this.container.retina.reduceFactor;

              if (this.delay < optDelay) {
                this.delay += delta.value;
              }

              if (!(this.delay < optDelay)) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              canEmit = true;

              if (trailOptions.pauseOnStop) {
                if (container.interactivity.mouse.position === this.lastPosition || ((_a = container.interactivity.mouse.position) === null || _a === void 0 ? void 0 : _a.x) === ((_b = this.lastPosition) === null || _b === void 0 ? void 0 : _b.x) && ((_c = container.interactivity.mouse.position) === null || _c === void 0 ? void 0 : _c.y) === ((_d = this.lastPosition) === null || _d === void 0 ? void 0 : _d.y)) {
                  canEmit = false;
                }
              }

              if (container.interactivity.mouse.position) {
                this.lastPosition = {
                  x: container.interactivity.mouse.position.x,
                  y: container.interactivity.mouse.position.y
                };
              } else {
                delete this.lastPosition;
              }

              if (canEmit) {
                container.particles.push(trailOptions.quantity, container.interactivity.mouse, trailOptions.particles);
              }

              this.delay -= optDelay;

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container,
          options = container.actualOptions,
          mouse = container.interactivity.mouse,
          events = options.interactivity.events;
      return mouse.clicking && mouse.inside && !!mouse.position && isInArray("trail", events.onClick.mode) || mouse.inside && !!mouse.position && isInArray("trail", events.onHover.mode);
    }
  }, {
    key: "reset",
    value: function reset() {}
  }]);

  return TrailMaker;
}(ExternalInteractorBase);